import {shuffle} from 'lodash';

const randoms = [
	'Quality of information',
	'Accuracy',
	'Knowledge ',
	'Relevance',
	'Speed of interaction',
	'Sound clarity',
	'Ease of use',
	'Speaking style',
];

const always = [
	'Overall satisfaction',
];

export const pickQuestions = (count: number = 2): string[] => {
	// Shuffle and pick random questions
	const shuffled = shuffle([...randoms]);
	const selected = shuffled.slice(0, count - always.length);

	// Combine with always questions
	return [...selected, ...always];
};
